import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { ApiService } from '../services/api.service';
import { LocalStorageService } from '../services/local-storage.service';
import { catchError, map, of, tap } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { ToastrService } from 'ngx-toastr';
import Keycloak from 'keycloak-js';

let infoLoaded = false;

export const authGuard: CanActivateFn = (route, state) => {
  const apiService = inject(ApiService);
  const lsService = inject(LocalStorageService);
  const authService = inject(AuthService);
  const toastrService = inject(ToastrService);
  const keycloak = inject(Keycloak);

  // Per-env keycloak-realm differentiation removed (see app.config.ts
  // for the matching change). All envs default to the 'agents' realm
  // and the public landing; the previous prod-only forced
  // `lsService.setItem('agRealm', 'admins')` is gone. Admin users opt
  // into the 'admins' realm via the existing localStorage override.
  const agRealm = lsService.getItem('agRealm');

  if (!keycloak.authenticated) {
    const fullUrl = window.location.pathname + window.location.search + window.location.hash;
    authService.saveRedirectedUrl(fullUrl);
  }

  if (infoLoaded || !keycloak.authenticated || agRealm !== 'agents') {
    return of(true);
  }

  return apiService.getAccountInfo().pipe(
    tap(result => {
      infoLoaded = true;

      lsService.setItem('agency', result.agency);
      lsService.setItem('agencyID', result.agency_id);
      lsService.setItem('consumer', result.consumer);
    }),
    map(result => {
      authService.isUserDataReceived.next(true);
      if (result.role !== 'manager' && result.role !== 'subagency_manager') {
        toastrService.warning(
          'Access denied: Only agency managers are allowed.',
          'Unauthorized Role',
          {
            timeOut: 0,
            extendedTimeOut: 0,
            tapToDismiss: false,
          }
        );
        return false;
      }
      return true;
    }),
    catchError(err => {
      console.error('Failed to load account info', err);
      toastrService.error(err.error?.error || 'Failed to load account info', 'Error');
      authService.isUserDataReceived.next(false);
      return of(true);
    })
  );
};
